<template>
  <!-- Infrastructure Solution Section -->
  <section
    class="infrastructure-section text-white d-flex align-items-center industryhero"
  >
    <!-- Overlay for darker background -->
    <div
      class="overlay"
      style="
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 50, 0.6);
        z-index: 1;
      "
    ></div>

    <div class="container position-relative" style="z-index: 2">
      <div class="row align-items-center">
        <!-- Left Content -->
        <div class="col-lg-6 text-start">
          <h1 class="fw-bold text-uppercase">Industry Solution</h1>
          <p class="lead">Fasilitas Layanan Komunikasi dan Teknologi di Berbagai Sektor Industri yang Menjamin Anda Mendapatkan Konektivitas Terbaik</p>
          <a
            href="#explore"
            class="btn btn-orange rounded-pill px-5 btn-lg fw-bold px-4"
            >Explore</a
          >
        </div>
      </div>
    </div>
  </section>

<section class="position-relative py-5">
  <!-- 1. Maritime -->
  <div class="industry-section position-relative mb-5">
    <div class="bg-oilgas d-flex align-items-center justify-content-start p-4">
      <h2 class="text-white">Maritime and Oil & Gas Industry</h2>
    </div>
    <div class="blue-overlay d-flex bgo-blue align-items-center justify-content-center p-5" style="opacity: calc(0.8);">
      <div class="overlay-content">
        <p class="text-white">
          Manajemen operasional maritim dan O&G lebih efektif dengan infrastruktur ICT dan solusi VSAT yang terpadu.
        </p>
        <button data-bs-toggle="modal" data-bs-target="#Industry1" type="button" 
                class="btn btn-sm btn-outline-light me-2 text-uppercase italic-btn-outline" 
                style="border-radius: 0 !important;">
          Click to Know More
        </button>
      </div>
    </div>
  </div>

  <!-- 2. Mining -->
  <div class="industry-section position-relative mb-5">
    <div class="bg-energy d-flex align-items-center justify-content-start p-4">
      <h2 class="text-white">Energy & Mineral
Resources</h2>
    </div>
    <div class="blue-overlay d-flex bgo-orange align-items-center justify-content-center p-5" style="opacity: calc(0.8);">
      <div class="overlay-content">
        <p class="text-white">
          Skyreach telah terdaftar di CIVD untuk dukung industri energi dan sumber daya yang fleksibel, melalui  solusi teknologi dan komunikasi yang andal
        </p>
        <button data-bs-toggle="modal" data-bs-target="#Industry2" type="button" 
                class="btn btn-sm btn-outline-light me-2 text-uppercase italic-btn-outline" 
                style="border-radius: 0 !important;">
         Click to Know More
        </button>
      </div>
    </div>
  </div>

  <!-- 3. Oil & Gas -->
  <div class="industry-section position-relative mb-5">
    <div class="bg-plantation d-flex align-items-center justify-content-start p-4">
      <h2 class="text-white">Plantation
Technology</h2>
    </div>
    <div class="blue-overlay bgo-green d-flex align-items-center justify-content-center p-5" style="opacity: calc(0.8);">
      <div class="overlay-content">
        <p class="text-white">
          Solusi perkebunan dan pertanian membantu bisnis Anda untuk mengetahui bagaimana bisnis Anda berjalan 
        </p>
        <button data-bs-toggle="modal" data-bs-target="#Industry3" type="button" 
                class="btn btn-sm btn-outline-light me-2 text-uppercase italic-btn-outline" 
                style="border-radius: 0 !important;">
         Click to Know More
        </button>
      </div>
    </div>
  </div>

  <!-- 4. Plantation -->
  <div class="industry-section position-relative mb-5">
    <div class="bg-government d-flex align-items-center justify-content-start p-4">
      <h2 class="text-white">Government
Sector</h2>
    </div>
    <div class="blue-overlay d-flex bgo-tosca align-items-center justify-content-center p-5" style="opacity: calc(0.8);">
      <div class="overlay-content">
        <p class="text-white">
         Solusi Teknologi Informasi dan Komunikasi terpadu yang aman, dibuat oleh anak bangsa untuk Indonesia & dunia
        </p>
        <button data-bs-toggle="modal" data-bs-target="#Industry4" type="button" 
                class="btn btn-sm btn-outline-light me-2 text-uppercase italic-btn-outline" 
                style="border-radius: 0 !important;">
         Click to Know More
        </button>
      </div>
    </div>
  </div>

  <!-- 5. Transportation -->
  <div class="industry-section position-relative mb-5">
    <div class="bg-aviation d-flex align-items-center justify-content-start p-4">
      <h2 class="text-white">Aviation
Connectivity</h2>
    </div>
    <div class="blue-overlay d-flex bgo-white align-items-center justify-content-center p-5" style="opacity: calc(0.8);">
      <div class="overlay-content">
        <p class="text-white">
         Tingkatkan nilai bisnis sektor aviasi dengan fasilitas onboard connectivity demi kenyamanan dalam tiap penerbangan 
        </p>
        <button data-bs-toggle="modal" data-bs-target="#Industry5" type="button" 
                class="btn btn-sm btn-outline-light me-2 text-uppercase italic-btn-outline" 
                style="border-radius: 0 !important;">
         Click to Know More
        </button>
      </div>
    </div>
  </div>
</section>





  <!--INDUSTRY 1 MODAL-->
  <div class="modal  fade" id="Industry1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="Industry1Label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable ">
      <div class="modal-content rounded-none">
        <div class="modal-header">
          <h1 class="modal-title fs-5 kebaikan text-blue" id="Industry1Label">{{ $t('Industry_Tagline') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="@/assets/images/Industry_1.png" class="w-100" style="object-fit: contain;" alt="">
          <div class="w-100 p-5 pb-0 text-dark">
            <p class="fw-bold">
              {{ $t('Industry_suitable_for') }} :
            </p>
            <ul style="list-style: circle">
              <li>{{ $t('Industry_1_1') }}</li>
            </ul>

          </div>
          <div class="w-100 p-5 pt-0 pb-0 text-dark">
            <p class="fw-bold">
              {{ $t('Industry_skyreach_sol') }} :
            </p>
            <ul style="list-style: circle">
              <li>{{ $t('Industry_1_2_1') }}</li>
              <li>{{ $t('Industry_1_2_2') }}</li>
              <li>{{ $t('Industry_1_2_3') }}</li>
              <li>{{ $t('Industry_1_2_4') }}</li>
              <li>{{ $t('Industry_1_2_5') }}</li>
            </ul>

          </div>

        </div>
        <div class="modal-footer"></div>

      </div>
    </div>
  </div>




  <!--INDUSTRY 2 MODAL-->
  <div class="modal  fade" id="Industry2" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="Industry2Label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable ">
      <div class="modal-content rounded-none">
        <div class="modal-header">
          <h1 class="modal-title fs-5 kebaikan text-blue" id="Industry2Label">{{ $t('Naturalrs_Title') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="@/assets/images/Industry_2.png" class="w-100" style="object-fit: contain;" alt="">
          <div class="w-100 p-5 pb-0 text-dark">
            <p class="fw-bold">
              {{ $t('Industry_suitable_for') }} :
            </p>
            <ul style="list-style: circle">
              <li>{{ $t('Industry_2_1') }}</li>
            </ul>

          </div>
          <div class="w-100 p-5 pt-0 pb-0 text-dark">
            <p class="fw-bold">
              {{ $t('Industry_skyreach_sol') }} :
            </p>
            <ul style="list-style: circle">
              <li>{{ $t('Industry_2_2_1') }}</li>
              <li>{{ $t('Industry_2_2_2') }}</li>
              <li>{{ $t('Industry_2_2_3') }}</li>
              <li>{{ $t('Industry_2_2_4') }}</li>
            </ul>

          </div>

        </div>
        <div class="modal-footer"></div>

      </div>
    </div>
  </div>


  <!--INDUSTRY 3 MODAL-->
  <div class="modal  fade" id="Industry3" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="Industry3Label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable ">
      <div class="modal-content rounded-none">
        <div class="modal-header">
          <h1 class="modal-title fs-5 kebaikan text-blue" id="Industry3Label">{{ $t('Media_Title') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="@/assets/images/Industry_3.png" class="w-100" style="object-fit: contain;" alt="">
          <div class="w-100 p-5 pb-0 text-dark">
            <p class="fw-bold">
              {{ $t('Industry_suitable_for') }} :
            </p>
            <ul style="list-style: circle">
              <li>{{ $t('Industry_3_1') }}</li>
            </ul>

          </div>
          <div class="w-100 p-5 pt-0 pb-0 text-dark">
            <p class="fw-bold">
              {{ $t('Industry_skyreach_sol') }} :
            </p>
            <ul style="list-style: circle">
              <li>{{ $t('Industry_3_2_1') }}</li>
              <li>{{ $t('Industry_3_2_2') }}</li>
              <li>{{ $t('Industry_3_2_3') }}</li>
            </ul>

          </div>

        </div>
        <div class="modal-footer"></div>

      </div>
    </div>
  </div>



  <!--INDUSTRY 4 MODAL-->
  <div class="modal  fade" id="Industry4" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="Industry4Label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable ">
      <div class="modal-content rounded-none">
        <div class="modal-header">
          <h1 class="modal-title fs-5 kebaikan text-blue" id="Industry4Label">{{ $t('Goverment_Title') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="@/assets/images/Industry_4.png" class="w-100" style="object-fit: contain;" alt="">
          <div class="w-100 p-5 pb-0 text-dark">
            <p class="fw-bold">
              {{ $t('Industry_suitable_for') }} :
            </p>
            <ul style="list-style: circle">
              <li>{{ $t('Industry_4_1_1') }}</li>
              <li>{{ $t('Industry_4_1_2') }}</li>
            </ul>

          </div>
          <div class="w-100 p-5 pt-0 pb-0 text-dark">
            <p class="fw-bold">
              {{ $t('Industry_skyreach_sol') }} :
            </p>
            <ul style="list-style: circle">
              <li>{{ $t('Industry_4_2_1') }}</li>
              <li>{{ $t('Industry_4_2_2') }}</li>
            </ul>
          </div>

        </div>
        <div class="modal-footer"></div>

      </div>
    </div>
  </div>



  <!--INDUSTRY 5 MODAL-->
  <div class="modal  fade" id="Industry5" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="Industry5Label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable ">
      <div class="modal-content rounded-none">
        <div class="modal-header">
          <h1 class="modal-title fs-5 kebaikan text-blue" id="Industry5Label">{{ $t('Aviation_Title') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="@/assets/images/Industry_5.png" class="w-100" style="object-fit: contain;" alt="">
          <div class="w-100 p-5 pb-0 text-dark">
            <p class="fw-bold">
              {{ $t('Industry_suitable_for') }} :
            </p>
            <ul style="list-style: circle">
              <li>{{ $t('Industry_5_1') }}</li>
            </ul>

          </div>
          <div class="w-100 p-5 pt-0 pb-0 text-dark">
            <p class="fw-bold">
              {{ $t('Industry_skyreach_sol') }} :
            </p>
            <ul style="list-style: circle">
              <li>{{ $t('Industry_5_2') }}</li>
            </ul>

          </div>

        </div>
        <div class="modal-footer"></div>

      </div>
    </div>
  </div>
</template>